import http from './httpService';

export const getPublicToken = () => {
    return http.get(`${process.env.REACT_APP_OSS_API}/token`);
};
